import humps from "humps";

export default store => next => action => {
  if (!action.error && action.payload) {
    return next({ ...action, payload: humps.camelizeKeys(action.payload) });
  } else {
    return next(action);
  }
};
